import {assert} from '@appscience/utils'
import {Store} from '@reatom/core'
import {createPrimitiveAtom} from '@reatom/core/primitives'
import {getTime, hoursToMilliseconds} from 'date-fns'
import {indexBy} from 'ramda'
import {getApi} from '../../api'

let lastInitTimestamp: number | null

export const itemStatusesAtom = createPrimitiveAtom<
  Record<string, TitleWithId>
>({})

export async function updateItemStatusesAtom({dispatch}: Store) {
  if (
    lastInitTimestamp &&
    lastInitTimestamp + hoursToMilliseconds(2) > getTime(new Date())
  ) {
    return
  }
  const data = await getApi().listsApi.getItemStatuses()
  const record = indexBy(x => x.id, data)
  dispatch(itemStatusesAtom.set(record))
  lastInitTimestamp = getTime(new Date())
  return record
}

export function getItemStatusTitle(id: string) {
  return (
    assert(
      itemStatusesAtom.getState()[id],
      `ItemStatusesAtom error: status with id "${id}" not found`,
    )?.title || ''
  )
}
